const KEEPALIVE_PING_TIMEOUT = 20000

export default class KeepAlive {
  public static isPong (event: any) {
    let data: any = {}
    try {
      data = JSON.parse(event.data)
    } catch (e) { }
    return data.pong === 'PONG'
  }

  public static sendPing (socket: WebSocket) {
    socket.send(JSON.stringify({ ping: 'PING' }))
  }

  private keepaliveTimeout: ReturnType<typeof setTimeout> | null = null
  private socket: WebSocket

  constructor (socket: WebSocket) {
    this.socket = socket
    this.queue()
  }

  public clear () {
    if (this.keepaliveTimeout != null) {
      clearTimeout(this.keepaliveTimeout)
      this.keepaliveTimeout = null
    }
  }

  public restart () {
    this.clear()
    this.queue()
  }

  private queue () {
    this.keepaliveTimeout = setTimeout(this.fire.bind(this), KEEPALIVE_PING_TIMEOUT)
  }

  private fire () {
    KeepAlive.sendPing(this.socket)
    this.queue()
  }
}
